import React from "react";
import { Box } from "@mantine/core";
import { ThreeDViewer } from "./ThreeDViewer";
import { ThreeDStatistics } from "./ThreeDStatistics";
import { DebugItemIn2d } from "./DebugItemIn2d";
import { PolygonInfo } from "./PolygonInfo";
import { ConsoleLogViewer } from "./ConsoleLogViewer";

type Props = {};

export const Debug3d: React.FC<Props> = () => {
  return (
    <Box h="100vh" p="md">
      <Box
        h="100%"
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gridTemplateRows: "1fr 1fr",
          gap: "var(--mantine-spacing-md)",
        }}
      >
        {/* Kvadrant 1 */}
        <Box
          style={{
            border: "1px solid var(--mantine-color-gray-4)",
            height: "100%",
            minHeight: 0,
          }}
        >
          <ThreeDViewer />
        </Box>

        {/* Kvadrant 2 */}
        <Box
          style={{
            border: "1px solid var(--mantine-color-gray-4)",
            height: "100%",
            minHeight: 0,
          }}
        >
          <DebugItemIn2d />
        </Box>

        {/* Kvadrant 3 */}
        <Box
          style={{
            border: "1px solid var(--mantine-color-gray-4)",
            height: "100%",
            minHeight: 0,
          }}
        >
          <ConsoleLogViewer />
        </Box>

        {/* Kvadrant 4 */}
        <Box
          style={{
            border: "1px solid var(--mantine-color-gray-4)",
            height: "100%",
            minHeight: 0,
          }}
        >
          <PolygonInfo />
        </Box>
      </Box>
    </Box>
  );
};
